import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Project, Utils } from '../classes';
import { API_URL } from '../config';

@Injectable()
export class ProjectService {
  constructor(private http: HttpClient) {}

  getProjects(): Observable<{ projects: Project[]; can_add: boolean }> {
    return this.http.get(`${API_URL}/project/`).pipe(
      map((data: { objects: any[]; can_add: boolean }) => ({
        projects: data.objects.map(
          item => new Project(Object.assign(item, { base_map: item.base_map ? Utils.createBaseLayerObject(item.base_map) : null }))
        ),
        can_add: data.can_add
      })),
      catchError(this.handleError)
    );
  }

  saveProject(project: Project): Observable<any> {
    let data: any = {
      name: project.name,
      extent: project.extent,
      public: project.public,
      type: 'm',
      preview: project.preview,
      parameters: project.parameters
    };

    if (project.id) {
      data.id = project.id;
    }

    if (project.base_map) {
      data.baseMapId = project.base_map.id;
    }

    if (project.preview && typeof project.preview !== 'string') {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (key === 'parameters') {
          formData.append(key, JSON.stringify(data[key]));
          return;
        }
        formData.append(key, data[key]);
      });
      data = formData;
    }

    return this.http.post(`${API_URL}/project/`, data).pipe(catchError(this.handleError));
  }

  deleteProject(project: Project): Observable<any> {
    return this.http.delete(project.resource_uri).pipe(catchError(this.handleError));
  }

  findByName(name: string) {
    return this.http.get(`${API_URL}/project/?name__iexact=${name}`).pipe(catchError(this.handleError));
  }

  private handleError(ex: any) {
    const msg = 'Reguest error:' + ex;
    console.error(msg);
    return observableThrowError(msg);
  }
}
